import BillingRule from "../entities/billing-rule";
import ClientLike from "@/api/client-like";

export default class BillingRuleApi {
  constructor(private client: ClientLike) {}

  async findByProject(
    projectId: string,
    isPurchase: 0 | 1 = 0,
    isOriginal = false
  ): Promise<BillingRule> {
    const rule = await this.client.get("get_billing_rule.php", {
      projectId,
      isPurchase
    });
    if (isOriginal) {
      return new BillingRule(rule.monthRule, rule.dayRule, rule.cutoffRule);
    }
    return new BillingRule(
      rule.monthRule,
      rule.dayRule || 31,
      rule.cutoffRule || 31
    );
  }
}
